module.exports = __webpack_public_path__ + "static/img/梯形背景.2b3330c1.png";